<template>
<div>
     <m-welcome-numbering-plan
        :profile="profile"
        v-on:update-profile="$emit('reload')"
        v-on:reload="$emit('reload')"
    />

    <p>
        <v-switch
            label="This section is complete (does not mark the phone number plan as complete on the welcome screen)"
            v-model="profile.provision_info.complete_phone_number_plan"
            v-on:change="onChangeCompleteSwitch"
        />
    </p>

</div>
</template>

<script>
export default {
    props: {
         profile: {
            type: Object,
            default: function() { return null; }
        },
    },

    methods: {
        onChangeCompleteSwitch() {
            this.$rc.rest({
                'spinner': true,
                'endpoint': 'PUT: /api/v1/provision/provision-info',
            
                'params' : this.profile.provision_info,
            
                'on_success': (data) => {
                        this.$emit('reload');
                    },
            
                'on_error': 'Unable to mark the phone number plan section as complete',
            });
        }
    },
}
</script>

<style lang="scss" scoped>

</style>